import type { AppModule } from '@/types/architecture'
import routes from './routes'

/**
 * Panel Optimizer Module — ACM Panel Cutting Optimization
 *
 * Enables estimators to submit panel demand lists, compute optimal
 * sheet layouts via OR-Tools solver, and visualize cutting patterns
 * to minimize material waste and produce purchasing lists.
 */
const optimizerModule: AppModule = {
    id: 'optimizer',
    navigation: {
        label: 'Panel Optimizer',
        icon: 'panel-layout',
        path: '/optimizer',
        order: 78,
        moduleKey: 'panel_optimizer',
        pages: [
            {
                label: 'Jobs',
                path: '/optimizer',
                icon: 'list',
            },
            {
                label: 'Material Presets',
                path: '/optimizer/presets',
                icon: 'layers',
            },
            {
                label: 'Templates',
                path: '/optimizer/templates',
                icon: 'bookmark',
            },
        ],
    },
    routes,
}

export default optimizerModule
